import { HCO_CUBE_NAME } from '@/api/hco/constants';
import { FilterConfigStatic } from '@/types/filter';
import { BinaryFilter } from '@cubejs-client/core';
import { SourceSytem } from '../general/sourceSystemFilter';

const SOURCE_SYSTEM_MEMBERS: Record<SourceSytem, string> = {
  [SourceSytem.OCEP]: `${HCO_CUBE_NAME}.is_in_ocep`,
  [SourceSytem.RELTIO]: `${HCO_CUBE_NAME}.is_in_reltio`,
};

const isSourceSystem = (value: string): value is SourceSytem =>
  value === SourceSytem.OCEP || value === SourceSytem.RELTIO;

const hcoSourceSystemFilter: FilterConfigStatic = {
  label: 'global.filters.formControls.hcoSourceSystemLabel',
  placeholder: 'global.filters.formControls.hcoSourceSystemPlaceholder',
  options: [
    { value: SourceSytem.OCEP, label: 'OCE-P' },
    { value: SourceSytem.RELTIO, label: 'Reltio' },
  ],
  defaultValue: [],
  type: 'multiselect',
  clearable: true,
  format: ({ value, t }) => {
    const values = Array.isArray(value) ? value.map(String) : [String(value)];
    return values
      .filter(isSourceSystem)
      .map(system => t('global.filters.sourceSystems.inPrefix', { value: t(`global.filters.sourceSystems.${system}`) }))
      .join(', ');
  },
  applyFilter: value => {
    const selected = Array.isArray(value) ? value.map(String) : [];
    const orConditions: BinaryFilter[] = selected.filter(isSourceSystem).map(system => ({
      member: SOURCE_SYSTEM_MEMBERS[system],
      operator: 'equals',
      values: ['true'],
    }));
    if (orConditions.length === 0) return undefined;
    return { or: orConditions };
  },
};

export default hcoSourceSystemFilter;
